import { useLayoutEffect, useState } from "react";

function useApp() {
    const [permissionAllowed, setPermissionAllowed] = useState<boolean>(false);

    useLayoutEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        if (params.token === "mb3OXuihYk2KCWYmC8pMBw8TZUS7VxGJc") {
            setPermissionAllowed(true);
        }
    }, []);

    return {
        permissionAllowed
    }
}

export default useApp;